import {
  border2,
  radius,
  rem,
  spacing,
  token,
} from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const styles = [
  css`
    :host {
      box-sizing: border-box;
      display: block;
      --chevron-color: ${token('status-info-border')};
      --hover-color: ${token('background-tertiary')};
      --summary-background: ${token('background-secondary')};
      --text-color: ${token('foreground-primary')};
      --icon-color: ${token('text-secondary')};
    }

    :host([active]) {
      --chevron-color: ${token('foreground-inverse')};
      --hover-color: ${token('status-info-background-hover-inverted')};
      --summary-background: ${token('status-info-background-inverted')};
      --text-color: ${token('foreground-inverse')};
      --icon-color: ${token('foreground-inverse')};
    }

    :host([secondary]) {
      --chevron-color: ${token('foreground-primary')};
      --hover-color: ${token('background-primary')};
      --text-color: ${token('foreground-primary')};
      --icon-color: ${token('foreground-primary')};
    }

    :host([secondary][active]) {
      --hover-color: ${token('status-neutral-background-hover')};
      --summary-background: ${token('status-neutral-background-hover')};
      --text-color: ${token('foreground-primary')};
      --icon-color: ${token('foreground-primary')};
    }

    :where(a-accordion) {
      &:not(.toc-item--has-actions) {
        &::part(summary):hover {
          background: var(--hover-color);
        }
      }

      &::part(summary) {
        background: var(--summary-background);
        color: var(--text-color);
      }

      &.toc-item--has-actions::part(summary) {
        border-radius: ${radius('medium')};
        display: flex;
        gap: 0;
        overflow: hidden;
        padding: 0;
      }

      &.toc-item--has-actions::part(chevron) {
        align-self: stretch;
        display: flex;
        inline-size: ${rem(40)};
        justify-content: center;
      }

      &.toc-item--has-actions::part(chevron):hover {
        background: var(--hover-color);
      }

      [slot='summary'] {
        display: flex;
        font-weight: 600;
        justify-content: space-between;
      }
    }

    :where(.marker-container) {
      display: flex;
      gap: ${spacing(75)};
    }

    :where(.toc-item-wrapper) {
      background: var(--summary-background);
      border-radius: ${radius('medium')};
      color: var(--text-color);
      display: flex;
      justify-content: space-between;
      overflow: hidden;

      &:not(.toc-item--has-actions):not(:has(a-toc-action)) {
        padding: var(--toc-item-wrapper-padding);
      }

      :host([secondary]) {
        border: ${border2(1, 'albert-toc-item-border-secondary', 'solid')};
        border-radius: ${radius('large')};
      }

      :host([secondary][active]) {
        --summary-background: ${token('status-neutral-background-hover')};
        border: ${border2(1, 'border-primary', 'solid')};
        border-radius: ${radius('large')};
      }

      :host([secondary][collapsed]) {
        inline-size: ${rem(50)};
        margin: 0 auto;
      }
    }

    :where(a-toc-action:first-of-type)::part(button) {
      border-end-start-radius: ${radius('medium')};
      border-start-start-radius: ${radius('medium')};
    }

    :where(a-toc-action:last-of-type)::part(button) {
      border-end-end-radius: ${radius('medium')};
      border-start-end-radius: ${radius('medium')};
    }

    :host:has(a-accordion) {
      padding-block: ${spacing(75)};

      &([active]) {
        & a-accordion::part(summary) {
          border-radius: ${radius('large')};
        }
      }
    }
  `,
];
